var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z",
    fill: "#00BC62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12L21 3",
    stroke: "#00BC62",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3641 5.63499C16.7698 4.04388 14.6364 3.10909 12.386 3.01557C10.1355 2.92205 7.93192 3.67661 6.21114 5.12996C4.49037 6.58331 3.37776 8.62958 3.09343 10.864C2.80911 13.0983 3.37377 15.3581 4.67571 17.1961C5.97765 19.034 7.92203 20.3164 10.1242 20.7895C12.3263 21.2626 14.6258 20.8919 16.5678 19.7508C18.5097 18.6097 19.9526 16.7812 20.611 14.6272C21.2695 12.4732 21.0954 10.1505 20.1234 8.11868",
    stroke: "#00BC62",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1817 8.81792C14.4378 8.07399 13.4566 7.61426 12.4089 7.51863C11.3611 7.42301 10.313 7.69754 9.44665 8.2945C8.5803 8.89147 7.95052 9.77313 7.66676 10.7862C7.383 11.7994 7.4632 12.8799 7.89343 13.84C8.32366 14.8001 9.07671 15.5791 10.0217 16.0417C10.9667 16.5042 12.0439 16.6209 13.066 16.3717C14.0882 16.1224 14.9907 15.5229 15.6166 14.6772C16.2426 13.8316 16.5525 12.7934 16.4924 11.743",
    stroke: "#00BC62",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveIcon);
export default __webpack_public_path__ + "static/media/activeIcon.7680234c87a13eda6c45891e38cfd8fb.svg";
export { ForwardRef as ReactComponent };